import { ref } from 'vue';

const selectedItems = ref<string[] | []>([]);
const totalItems = ref(0);
export const useSelectedItems = () => {
  const setSelectedItems = (users: string[]) => {
    selectedItems.value = users;
  };

  const clearSelectedItems = () => {
    selectedItems.value = [];
  };

  return {
    totalItems,
    selectedItems,
    setSelectedItems,
    clearSelectedItems,
  };
};
